!function(){const e=()=>{const e=n.dataset.url;fetch(e).then((e=>e.text())).then((e=>{const n=document.createElement("div");n.innerHTML=e;const t=document.querySelector(".product-recommendations"),o=n.querySelector(".product-recommendations");o&&o.innerHTML.trim().length&&(t.innerHTML=o.innerHTML)})).catch((e=>{console.error(e)}))},n=document.querySelector(".product-recommendations"),t=new IntersectionObserver(((t,o)=>{t[0].isIntersecting&&(o.unobserve(n),e())}),{rootMargin:"0px 0px 200px 0px"});n&&t.observe(n),Shopify.designMode&&document.addEventListener("shopify:section:load",(()=>{e()}))}();

jQuery('document').ready(function($){
  //Feature Product
  var recomm_prod_interval = setInterval(function() {
    if($('#recomm_prod_slider product-card').length > 0) {
      setTimeout(function () {
        var $recomm_prod_slider = $('.recomm_prod_lists').find('.recomm_prod_slider');
        var $recomm_progressBar = $('.recomm_progress');
        
        $recomm_prod_slider.on('init', function(event, slick) {
          var calc = ((slick.options.slidesToShow) / (slick.slideCount)) * 100;
          $recomm_progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc );
          if(slick.options.slidesToShow >= slick.slideCount) {
            $recomm_progressBar.addClass('progress_hide');
          }
        });
        
        $recomm_prod_slider.slick({
          speed: 1000,
          arrows: true,
          prevArrow: $('#recomm_prev'),
          nextArrow: $('#recomm_next'),
          autoplay: false,
          dots: false,
          focusOnSelect: true,
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
          {
            breakpoint: 1601,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1201,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2.3
            }
          },{
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },{
            breakpoint: 577,
            settings: {
              slidesToShow: 1
            }
          }
          ]
        });
        
        $recomm_prod_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
          var calc = ((slick.options.slidesToShow + nextSlide) / (slick.slideCount)) * 100;
          $recomm_progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc );
        });
       }, 1000);
       clearInterval(recomm_prod_interval);
    }
  }, 1000);
});